<section class="section breadcrumbs-custom">
    <div class="breadcrumbs-custom-main bg-image bg-primary">
        <div class="container">
            <h3 id="textInImage" class="breadcrumbs-custom-title">Θέσεις Εργασίας</h3>

        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a routerLink="/home">Αρχική</a></li>
                <li class="active">Θέσεις Εργασίας</li>
            </ul>
        </div>
    </div>
</section>

<div class="container" id="main-section">

    <!-- search bar -->
    <form (ngSubmit)="getJobListByKeyWordLocation()" [formGroup]="searchByFilterForm" *ngIf="metadata$ | async as metadata" class="form-layout-search form-lg">
        <!-- search by title -->
        <div class="form-wrap form-wrap-icon">
            <input formControlName="keywords" class="form-input" placeholder="Λέξεις κλειδιά" id="form-employer" type="text" name="employer" data-constraints="@Required">
            <label class="form-label sr-only" for="form-employer">Λέξεις Κλειδιά</label><span class="icon fl-bigmug-line-search74"></span>
        </div>
        <!-- search by location -->
        <div class="form-wrap form-wrap-icon form-wrap-select">
            <ng-select formControlName="locationId" [items]="locations$ | async" placeholder="Όλες οι περιοχές"  bindLabel="text" bindValue="id" id="general-information-job-category" name="resume-category">
            </ng-select>
        </div>

        <div class="form-wrap form-wrap-button">
            <button class="button button-lg button-primary" type="submit">Αναζητηση</button>
        </div>
    </form>
    <div class="row flex-row-reverse">
        <div class="col-xl-3 col-lg-3 col-sm-12">
            <div>
                <h4>ΦΙΛΤΡΑ</h4>
                <button *ngIf="isFiltered" class="btn btn-link" type="reset" (click)="discardfilters()">Ακύρωση
                    όλων</button>
            </div>
            <br />
            <form [formGroup]="searchByFilterForm" (ngSubmit)="getPostJobsList()" *ngIf="metadata$ | async as metadata">

                <div class="row row-30">
                    <div class="col-sm-6 col-lg-12">
                        <p class="heading-8">Ημερομηνια αναρτησης</p>
                        <hr>

                        <ul class="list list-xs">
                            <li>
                                <label class="job_listing_checkbox radioContainer">
                                    <input value="1" type="radio"
                                        (change)="getcreatedAfterDate($event.target.value)"
                                        formControlName="createdAfterCheck">Τελευταίες 24 ώρες <span class="count-filters"
                                        *ngIf="filters.creationDate['1']; else zeroResults">({{filters.creationDate['1']}})</span>
                                    <span class="radiomark"></span>
                                </label>

                            </li>
                            <li>
                                <label class="job_listing_checkbox radioContainer">
                                    <input value="3" type="radio"
                                        (change)="getcreatedAfterDate($event.target.value)"
                                        formControlName="createdAfterCheck">Τελευταίες 3 μερες <span class="count-filters"
                                        *ngIf="filters.creationDate['3']; else zeroResults">({{filters.creationDate['3']}})</span>
                                    <span class="radiomark"></span>
                                </label>

                            </li>
                            <li>
                                <label class="job_listing_checkbox radioContainer">
                                    <input value="7" type="radio"
                                        (change)="getcreatedAfterDate($event.target.value)"
                                        formControlName="createdAfterCheck">Τελευταίες 7 μέρες <span class="count-filters"
                                        *ngIf="filters.creationDate['7']; else zeroResults">({{filters.creationDate['7']}})</span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>

                            <li>
                                <label class="job_listing_checkbox radioContainer">
                                    <input value="30" type="radio"
                                        (change)="getcreatedAfterDate($event.target.value)"
                                        formControlName="createdAfterCheck">Τελευταίες 30 μέρες <span class="count-filters"
                                        *ngIf="filters.creationDate['30']; else zeroResults">({{filters.creationDate['30']}})</span>
                                    <span class="radiomark"></span>
                                </label>

                            </li>
                        </ul>
                    </div>

                    <!-- employment type -->
                    <div class="col-sm-6 col-lg-12" *ngIf="metadata$ | async as metadata">
                        <p class="heading-8">Τυπος θεσης εργασιας</p>
                        <hr>
                        <ul class="list list-xs">
                            <li>
                                <div class="job_listing_checkbox">
                                    <div *ngFor="let data of types; let i=index">
                                        <label class="checkBoxContainer">
                                            <input class="checkBoxInputs" type="checkbox" [checked]="data.selected"
                                                [value]="data.id" (change)="onCheckboxChange($event)" />
                                            {{data.text}} <span class="count-filters"
                                                *ngIf="filters.employmentType[data.id]; else zeroResults">({{filters.employmentType[data.id]}}) 
                                            </span>
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- Industry Search field-->
                    <div class="col-sm-6 col-lg-12">
                        <p class="heading-8">Κλαδος
                        </p>
                        <hr>
                        <!-- <div class="form-wrap form-wrap-select form-filled"> -->
                        <!-- <ng-select formControlName="industryId" (change)="selectedIndustryHandler($event)" [items]="industries$ | async" placeholder="Επίλεξε" id="general-information-job-category" name="resume-category" style="width: 100%">
                        </ng-select> -->
                        <!-- </div> -->
                        <ng-select (change)="selectedIndustryHandler($event)" placeholder="Επίλεξε" id="experience-industry" data-constraints="@Selected">
                            <ng-option *ngFor="let data of industries;" [value]="data.id">
                                {{data.text}} <span class="count-filters" *ngIf="filters.industry[data.id]; else zeroResults">({{filters.industry[data.id]}})
                                </span>
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- salary -->
                    <div class="col-sm-6 col-lg-12">
                        <p class="heading-8">Μισθος</p>
                        <hr>
                        <ul class="list list-xs">
                            <li>
                                <label class="job_listing_checkbox checkbox_info radioContainer">
                                    <input name="salary" value="1" type="radio"
                                        (change)="getSalary($event.target.value)" formControlName="salary">Έως 500€
                                    <span class="count-filters"
                                        *ngIf="filters.salary['0to500']; else zeroResults">({{filters.salary['0to500']}})
                                    </span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>
                            <li>
                                <label class="job_listing_checkbox checkbox_info  radioContainer">
                                    <input name="salary" value="2" type="radio"
                                        (change)="getSalary($event.target.value)" formControlName="salary">500€ -
                                    1000€ <span class="count-filters"
                                        *ngIf="filters.salary['500to1000']; else zeroResults">({{filters.salary['500to1000']}})
                                    </span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>
                            <li>
                                <label class="job_listing_checkbox checkbox_info  radioContainer">
                                    <input name="salary" value="3" type="radio"
                                        (change)="getSalary($event.target.value)" formControlName="salary">1000€ -
                                    1500€ <span class="count-filters"
                                        *ngIf="filters.salary['1000to1500']; else zeroResults">({{filters.salary['1000to1500']}})
                                    </span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>
                            <li>
                                <label class="job_listing_checkbox checkbox_info  radioContainer">
                                    <input name="salary" value="4" type="radio"
                                        (change)="getSalary($event.target.value)" formControlName="salary">1500€ -
                                    2000€ <span class="count-filters"
                                        *ngIf="filters.salary['1500to2000']; else zeroResults">({{filters.salary['1500to2000']}})
                                    </span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>
                            <li>
                                <label class="job_listing_checkbox checkbox_info  radioContainer">
                                    <input name="salary" value="5" type="radio"
                                        (change)="getSalary($event.target.value)" formControlName="salary">2000€+
                                    <span class="count-filters"
                                        *ngIf="filters.salary['greaterThan2000']; else zeroResults">({{filters.salary['greaterThan2000']}})
                                    </span>
                                    <span class="radiomark"></span>
                                </label>
                            </li>
                            <br />
                        </ul>

                    </div>
                    <ng-template #zeroResults>
                        <span class="count-filters">(0)</span>
                    </ng-template>
                </div>

                <hr>
            </form>
        </div>
        <div class="col-xl-9 col-lg-9 col-sm-12">
            <p *ngIf="totalElements>0"> Βρέθηκαν {{totalElements}} θέσεις εργασίας</p>
            <p *ngIf="totalElements==0"> Δεν βρέθηκαν θέσεις εργασίας</p>

            <div class="row job-row align-items-center big-screens" *ngFor="let content of items">
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-3">
                    <figure style="margin-right: -30px;" *ngIf="content.logo" class="company-minimal-figure1"><img class="company-minimal-image" src="{{content.logo}}" alt="" />
                    </figure>
                    <figure style="margin-right: -30px;" *ngIf="!content.logo" class="company-minimal-figure1"><img class="company-minimal-image" src="assets/images/defaultcompanylogo.jpg" alt="" />
                    </figure>
                </div>
                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-9">
                    <div class="row">
                        <div class="col-sm-12">
                            <h5>
                                <a [routerLink]="['/job-details', content.uuid]">{{content.title}}</a>
                            </h5>
                        </div>
                        <div class="col-xl-3">
                            <p *ngIf="content.locationName "><span style="color:grey; " class="icon icon-1 text-primary mdi mdi-map-marker "></span>{{content.locationName}} </p>
                            <p *ngIf="!content.locationName "> - </p>
                        </div>
                        <div class="col-xl-5 ">
                            <span>Ημ/νία ανάρτησης: {{content.creationDate|date: 'mediumDate'}}</span><br />
                            <span *ngIf="content.expirationDate ">Ημ/νία λήξης:
                            {{content.expirationDate|date: 'mediumDate'}}</span>
                        </div>
                        <div class="col-xl-4">
                            <span *ngIf="content.employmentTypesName=='Πρακτική Άσκηση' " class="badge pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Συμβασιούχος' " class="badge badge-secondary pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Ελεύθερος επαγγελματίας' " class="badge badge-tertiary pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Ασκούμενος' " class="badge badge-tertiary pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Μερική Απασχόληση' " class="badge badge-blue-11 pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Πλήρης Απασχόληση' " class="badge badge-yellow-12 pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Εποχική/Προσωρινή απασχόληση' " class="label-small-screen badge badge-season pull-right ovveride-pull-right-sm-screen">{{content.employmentTypesName}}</span>
                            <span *ngIf="content.employmentTypesName=='Μη διαθέσιμο' " class="badge badge-undefined pull-right ovveride-pull-right-sm-screen"></span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pagination-->
            <app-pagination-bs *ngIf="allJobs" [initialPage]="currentPage + 1" [items]="allJobs" [pageSize]="pageSize" (changePage)="onChangePage($event)"></app-pagination-bs>

        </div>
    </div>


</div>